import React from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { SIGNOL_COLOURS } from "@signolteam/shared/colours";
import { useDCContext, useAuthContext } from "@src/context";
import { useManagerContext } from "@src/context/managerContext";
import ManagerHooks from "@src/context/hooks/managerHooks";
import { AppUtils, SignolUtils } from "@src/utils";
import { Loader, Tooltip } from "@src/components/atoms";
import PieChartLib from "@src/components/graphs/PieChart";
import { ManagersBehaviourChangeCard } from "@src/components/cards/manager";
import OpportunityCountsAndPieChartCard from "./PerformanceDataCountsAndPieChartCard";

/**
 * Specific version of ManagersBehaviourChangeCard.
 * Assumes its for the currently selected behaviour, and fetches its own data.
 */
const PerformanceFuelSavingsVsPreCard = () => {
  const {
    selectedTeam,
    selectedPeriod,
    selectedBehaviour,
    selectedBehaviourColour,
  } = useManagerContext();
  const { getDynamicReplacement } = useDCContext();
  const auth = useAuthContext();

  const {
    data: fuelSavingsVsPreSignol = [],
    isPending: isPendingBehaviourFuelSavingsVsPre,
    error: errorBehaviourFuelSavingsVsPre,
  } = ManagerHooks.useGetBehaviourFuelSavingsVsPreSignol(
    auth.activeRole,
    selectedTeam?.id,
    selectedPeriod,
    AppUtils.endOfMonthIfValidDate(selectedPeriod),
  );

  if (isPendingBehaviourFuelSavingsVsPre) return <Loader />;

  if (errorBehaviourFuelSavingsVsPre)
    return (
      <div className="text-red-500">Error fetching fuel savings data...</div>
    );

  const currentFuelSavingsVsPre = fuelSavingsVsPreSignol?.find(
    (d) => d.behaviourAcronym === selectedBehaviour.behaviourAcronym,
  );
  if (currentFuelSavingsVsPre == null) return <></>;

  return (
    <ManagersBehaviourChangeCard
      isLoading={isPendingBehaviourFuelSavingsVsPre}
      behaviourColour={selectedBehaviourColour.name}
      attributeText={getDynamicReplacement(
        "fuel_manager__behaviour__avg_fuel_card__title",
      )}
      postSignolValue={
        currentFuelSavingsVsPre.avgNetFuelSavingKgPostSignol.value
      }
      postSignolStandardError={
        currentFuelSavingsVsPre.avgNetFuelSavingKgPostSignol.standardError95
      }
      changeVsPreValue={currentFuelSavingsVsPre.avgNetFuelSavingChangeKg.value}
      changeVsPreStandardError={
        currentFuelSavingsVsPre.avgNetFuelSavingChangeKg.standardError95
      }
      unit={"kg"}
      preSignolText={getDynamicReplacement(
        "fuel_manager__behaviour__avg_fuel_card__pre_signol_text",
      )}
      className="mb-6 md:mr-6"
    />
  );
};

export const performanceFuelSavingsVsPreCardControls = {};
PerformanceFuelSavingsVsPreCard.propTypes = AppUtils.getPropTypeFromControls(
  performanceFuelSavingsVsPreCardControls,
);
export default PerformanceFuelSavingsVsPreCard;
